import { color, spacing, font, media } from "@universityofmaryland/web-token-library";
import "../typography/font-face/index.js";
import "../typography/campaign.js";
import "../typography/elements.js";
import { medium, large } from "../typography/sans.js";
import "../typography/serif.js";
import "../typography/stats.js";
import { white } from "./text/link.js";
import { objectWithClassName } from "../utilities/create/jss.js";
import "../node_modules/.pnpm/postcss@8.5.8/node_modules/postcss/lib/postcss.js";
import "../node_modules/.pnpm/postcss-js@4.1.0_postcss@8.5.8/node_modules/postcss-js/index.js";
import "../node_modules/.pnpm/postcss-nesting@13.0.2_postcss@8.5.8/node_modules/postcss-nesting/dist/index.js";
import "../_virtual/index.js";
const classNamePrefix = "umd-table";
function composeInline(options) {
  const { theme = "light" } = options || {};
  const isThemeDark = theme === "dark";
  const className = [];
  if (isThemeDark) {
    className.push(`${classNamePrefix}-inline-dark`);
  } else {
    className.push(
      `${classNamePrefix}-inline`,
      /** @deprecated Use 'umd-table-inline' instead */
      `umd-rich-text-inline-table`
    );
  }
  return objectWithClassName({
    borderCollapse: "collapse",
    display: "block",
    overflowX: "auto",
    tableLayout: "fixed",
    maxWidth: "100%",
    "& th": large,
    "& strong, & b": {
      fontWeight: font.weight.bold
    },
    "& td": medium,
    "& th, & td": {
      padding: `${spacing.sm}`,
      verticalAlign: "top",
      [`@media (${media.queries.large.min})`]: {
        padding: `${spacing.md}`
      }
    },
    "& thead th": {
      background: color.black,
      color: color.white,
      textAlign: "left",
      borderTop: `2px solid ${color.red}`,
      ...isThemeDark && {
        background: color.gray.darker,
        borderTop: `2px solid ${color.gold}`
      },
      "& *": {
        color: "inherit"
      },
      "& a": {
        ...white,
        "&:hover, &:focus": {
          ...white["&:hover, &:focus"],
          backgroundImage: `linear-gradient(${color.red}, ${color.red})`,
          ...isThemeDark && {
            backgroundImage: `linear-gradient(${color.gold}, ${color.gold})`
          }
        }
      }
    },
    "& tbody tr": {
      borderTop: `1px solid ${color.gray.darker}`,
      ...isThemeDark && {
        borderTop: `1px solid ${color.gray.dark}`
      }
    },
    "& tr:nth-child(even)": {
      background: color.gray.lightest,
      ...isThemeDark && {
        background: color.gray.darker
      }
    },
    className
  });
}
const inline = composeInline();
const inlineDark = composeInline({ theme: "dark" });
export {
  composeInline,
  inline,
  inlineDark
};
//# sourceMappingURL=table.js.map
